<template>
  	<v-list class="py-0">
        <v-list-item two-line>
	        <v-list-item-avatar :size="48" color="secondary">
	            <v-flex class="text-center white--text">{{ inititals }}</v-flex>
	        </v-list-item-avatar>
	        <v-list-item-content>
	            <v-list-item-title>{{ full_name }}</v-list-item-title>
	            <v-list-item-subtitle>
	            	<span>{{ trans('user.last_online') }} </span>
	            	<span>{{ last_activity }}</span>
	            </v-list-item-subtitle>
	        </v-list-item-content>
        </v-list-item>
  	</v-list>
</template>
<script>
	
	import _ from 'lodash';

	export default {

		props: {
			user: {
				type: Object,
				default: () => ({
					uuid: null,
					email: null,
					phone_number: null,
					first_name: null,
					last_name: null,
					email_visible: false,
					phone_number_visible: false,
					last_name_visible: false,
					email_verified: false,
					phone_number_verified: false,
					activity: {
						last_active_at: null
					}
				})
		    },
		    type: {
		    	default: null,
		    }
		},

		computed: {

			first_name: function()
			{
				let name = _.get(this.user, 'first_name', this.trans('user.anonymous'));
				return name != null ? name : this.trans('user.anonymous');
			},

			last_name: function()
			{
				let last_name = _.get(this.user, 'last_name', false);
				let visible   = _.get(this.user, 'last_name_visible', false);
				if (visible && last_name) return last_name;
				return null;
			},

			full_name: function() 
			{
				if (this.last_name) {
					return `${this.first_name} ${this.last_name}`;
				} else {
					return this.first_name;
				}
			},

			inititals: function() 
			{
				let inititals = this.first_name.charAt(0);
				if (this.last_name) {
					inititals = inititals + '' + this.last_name.charAt(0);
				}
				return _.toUpper(inititals);
			},

			last_activity: function() 
			{
				let registered_at = _.get(this.user, 'created_at', null);
				let last_active_at = _.get(this.user, 'activity.last_active_at', registered_at);
				if (last_active_at) {
					return this.moment(last_active_at);
				}
				return this.trans('user.unknown_date');
			},

		},
	}
</script>